module.exports = {
    linkTemplate: '',
};
